import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ReactTabulator } from 'react-tabulator';
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import Sanc_003_01 from './sanc_003_01'

// 결재선관리 
const Sanc003 = () => {
	const { t,i18n }  = useTranslation();
	const oneMonthAgo = new Date();
	const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]                 = useState(false);
	const [approval_line_id,setApprovalLineId]  = useState('');
	const [responseData, setResponseData]       = useState([]);
	const [detailData, setDetailData]           = useState([]);
	const [userData,setUserData] 				= useState([])	
	const [approvalData,setApprovalData]        = useState([])
	const [filterField, setFilterField]         = useState('approval_name');
	const [filterType, setFilterType]           = useState('like');
	const [filterValue, setFilterValue]         = useState('');
	
	// 모달폼오픈
	const [showModal, setShowModal] = useState(false);
	
	const [storageId , setStorageId] = useState('')
	
	// Tabulator columns 목록
	const titleColunms = (t) => {
		return [
			{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
				cell.getRow().toggleSelect();
			}},
			{ title: t('LOAN_APPLICATION.결재선코드', { defaultValue: '결재선코드' }), field: 'approval_line_id', headerHozAlign: 'center', hozAlign: 'center', width: 120 , visible: false},
			{ title: t('APPROVAL.결재선명', { defaultValue: '결재선명' }), field: 'approval_name', headerHozAlign: 'center', hozAlign: 'center', width: 150, 
				formatter: function (cell, formatterParams, onRendered) {
					cell.getElement().style.fontWeight = 'bold';
					return cell.getValue();
				},
				cellClick:function(e, cell){
					const rowData = cell.getRow().getData();
					handleCellClick(rowData);
				},
				visible: false 
			},
			{ title: t('APPROVAL.결재순서', { defaultValue: '결재순서' }), field: 'approval_order', headerHozAlign: 'center', hozAlign: 'center', width:200 },
			{ title: t('APPROVAL.권한', { defaultValue: '권한' }), field: 'authority', headerHozAlign: 'center', hozAlign: 'center', width:300 },
			{ title: t('APPROVAL.결재자', { defaultValue: '결재자' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:300 },
		];
	}
	const [columns, setColumns]                 = useState(titleColunms(t));
	
	// Cell 클릭 이벤트(수정)
	const handleCellClick = (rowData) => {
		setStorageId(rowData.storage_id);
		handleModalOpen();
	}
	
	// 모달창오픈
	const handleModalOpen = () => {
		setShowModal(true);
		handleQuery();
	}

	// 모달창닫고, 재조회 
	const handleClose = () => {
		setStorageId('');
		setShowModal(false);
	}
	
	const [BranchCodeOptions, setBranchCodeOptions] 		= useState([]);	  // 지점
	const [StorageStatusOptions, setStorageStatusOptions] 	= useState([]);   // 보관함상태 
	

	// 조회 버튼 작동 시 실행되는 함수
	const fetchData  = async () => {
		setLoading(true);

		// API 호출 부분
		try {
			// 결재선 조회 
			const data = await API.fetchSanc003Data();

			const userData = await API.fetchSanc003UserData();
			const approvalData = await API.fetchSanc003ApprovalData({
				approval_line_id : approval_line_id
			});

			// 전달받은 데이터 중 다국어에 따라 Tabulator에 번역이 되어 display되게 하는 부분
			const translatedData = data.map(item => ({
				...item,
				authority 	: t(`AUTHORITY.${item.authority}`),
			}));

			// setResponseData(translatedData);
			// ID 존재 여부에 따라 데이터 저장을 다르게 한다.
			// 상세 모달 형식으로 넘어갈 때에는 번역된 데이터가 아닌 원본 데이터가 넘어가서
			// Select의 value가 지정되게 한다.
			// console.log('Data : ', data)
			// console.log('userData : ', userData)
			// console.log('approvalData : ', approvalData)

			setResponseData(translatedData);
			setUserData(userData);

			// storageId ? setDetailData(data) : setResponseData(translatedData);
			setLoading(false);
		} catch (error) {
			console.error('Error in fetchSacn003DataUpdateState:', error);
			setLoading(false);
		}
	};
	
	const handleQuery = useCallback(() => {
		if (!storageId) {
			setDetailData([]);
		}
	
		fetchData();
	}, [storageId, t]);

	useEffect(() => {
		setColumns(titleColunms(t))
		handleQuery();
	}, [i18n.language, t,handleQuery]);

	

	
	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			tableRef.current.setFilter(filterField, filterType, filterValue);
		}
	};

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};


	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('MENU_I18N.결재선 관리', { defaultValue: '결재선 관리' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					{/* <form action="/" method="POST"> */}
						<div className="row ms-0">
							<div className="form-group col-lg-11 col-md-12 col-xs-12 ps-0 rounded-2"></div>
							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>

							<div className="mt-3 mb-3 ps-0">
								<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
								<span> Filter</span>
							</div>

							<div className="collapse show" id="collapseExample">
								<div className="row">
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 mb-1 rounded-2">
										<select 
											id="filter-field" 
											className="form-select col-sm-3" 
											value={filterField}
											onChange={(e) => setFilterField(e.target.value)}
										>
											<option value="approval_name">{t('APPROVAL.결재선명', { defaultValue: '결재선명' })}</option>
											<option value="name">{t('APPROVAL.결재자', { defaultValue: '결재자' })}</option>
										</select>
									</div>
						
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 mb-1 rounded-2">
										<select 
											id="filter-type" 
											className="form-select col-sm-3"
											value={filterType}
											onChange={(e) => setFilterType(e.target.value)}
										>
											<option value="like">LIKE</option>
											<option value="=">=</option>
											<option value="<">&lt;</option>
											<option value="<=">&le;</option>
											<option value=">">&gt;</option>
											<option value=">=">&ge;</option>
											<option value="!=">!=</option>
										</select>
									</div>
						
									<div className="form-group col-lg-8 col-md-12 col-xs-12 ps-0 mb-3 rounded-2">
										<input 
											id="filter-value" 
											type="text" 
											className="form-control col-sm-6" 
											name="filter-value" 
											placeholder={t('COMMON.검색할 내용을 입력하세요', { defaultValue: '검색할 내용을 입력하세요' })}
											value={filterValue}
											onChange={(e) => setFilterValue(e.target.value)}
											onKeyUp={handleKeyUp}
										/>
									</div>
									<div className="row "></div>
								</div>
							</div>
						</div>
					{/* </form> */}
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				{/* <div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>총 {responseData.length}건</div> */}
				<ReactTabulator
					key={i18n.language  + JSON.stringify(columns)} // 이 부분을 추가하면 언어 변경 시마다 컴포넌트가 리렌더링됩니다.
					onRef={(r) => (tableRef.current = r.current)}
					columns={columns}
					data={responseData}
					options={{
						// layout: "fitColumns",
						layout: "fitDataStretch",
						groupBy: "approval_line_id",
						groupHeader: function (value, count, data, group) {
							return data[0].approval_name; // 예시로 첫 번째 데이터의 approval_name을 표시
						},
						// pagination: "local",
						// paginationSize: rowsPerPage,
						// paginationSizeSelector:[20, 40, 60, 80, 100],
						placeholder: "No Data Found",
					}}
					className="responsive-tabulator"
				/>
			</Card.Body>

			<div className="card-footer d-flex justify-content-start mt-auto">
				<button type="button" className="btn btn-outline-success mb-1 me-1 w-auto" onClick={handleModalOpen}>{t('APPROVAL.결재선 등록', { defaultValue: '결재선 등록' })}</button>
			</div>
			<Sanc_003_01 
				showModal={showModal}
				setShowModal={setShowModal} 
				handleClose={handleClose} 
				UserData={userData}
				handleQuery={handleQuery}
			/>
		</ Card>
	);
};

export default Sanc003;